import React from "react";
import EditableText from "./EditableText";
import { aboutParents } from "../mock";

const ParentPhoto = ({ src, alt, nameId, defaultName }) => (
  <div className="flex flex-col items-center">
    <div className="bg-white p-2 shadow-xl rounded-sm rotate-[-1.5deg] hover:rotate-0 transition-transform duration-300">
      <img
        src={src}
        alt={alt}
        className="w-[150px] h-[210px] sm:w-[170px] sm:h-[230px] object-cover"
        draggable={false}
      />
      <EditableText
        id={nameId}
        as="p"
        className="mt-2 text-[#3a2c22] font-semibold text-[13px] sm:text-sm tracking-wide text-center block px-1"
        style={{ fontFamily: "'Quicksand', system-ui, sans-serif" }}
      >
        {defaultName}
      </EditableText>
    </div>
  </div>
);

const AboutParents = () => {
  return (
    <section id="about" className="relative w-full bg-[#e2c5b0] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6">
        <EditableText id="about.title" as="h2"
            className="text-center block text-[#1a1a1a] font-semibold mb-12"
            style={{ fontFamily: "'Quicksand', system-ui, sans-serif", fontSize: "clamp(2rem, 4.5vw, 3.5rem)" }}>
          {aboutParents.title}
        </EditableText>

        <div className="relative">
          <div className="flex flex-col sm:flex-row justify-center sm:justify-between gap-8 sm:gap-0 sm:px-12 md:px-20 mb-[-30px] sm:mb-[-40px] relative z-10">
            <ParentPhoto
              src="/father.jpg"
              alt={aboutParents.fatherName}
              nameId="about.father.name"
              defaultName={aboutParents.fatherName}
            />
            <ParentPhoto
              src="/mother.jpg"
              alt={aboutParents.motherName}
              nameId="about.mother.name"
              defaultName={aboutParents.motherName}
            />
          </div>

          <div className="bg-[#4a2c25] text-[#f3e7d4] rounded-[28px] shadow-xl px-6 sm:px-12 md:px-16 pt-24 sm:pt-28 pb-10 md:pb-14">
            <EditableText id="about.body" as="p" multiline
               className="whitespace-pre-line leading-[1.85] text-base md:text-lg block"
               style={{ fontFamily: "'Quicksand', system-ui, sans-serif" }}>
              {aboutParents.body}
            </EditableText>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutParents;
